import axios from '@/libs/util.request'

export const permission = params => {
  return axios.post('/index/permission', params)
}
